import PropTypes from "prop-types"

// Helper function to get sort direction for ARIA
const getSortDirection = (sorter, field) => {
  if (!sorter || sorter.field !== field) return "none"
  return sorter.order === "ascend" ? "ascending" : "descending"
}

const getHeaders = (sorter) => [
  {
    title: "Date sent",
    dataIndex: "created_at",
    key: "created_at",
    sorter: true,
    ellipsis: true,
    width: "25%",
    "aria-sort": getSortDirection(sorter, "sort_by_created_at"),
    "aria-label": "Date Sent, sortable"
  },
  {
    title: "Subject",
    dataIndex: "subject",
    key: "subject",
    ellipsis: true,
    sorter: true,
    width: "25%",
    "aria-sort": getSortDirection(sorter, "subject"),
    "aria-label": "Subject"
  },
  {
    title: "Message",
    dataIndex: "message",
    key: "message",
    ellipsis: true,
    width: "50%",
    "aria-label": "Message"
  }
]

getHeaders.propTypes = {
  sorter: PropTypes.object
}

export { getHeaders }
